module.exports = __webpack_public_path__ + "img/svg/add.cd0a767bbb37dbd622fe244f93a8503a.svg";